export const sections = [
  {
    section: "Overview",
    FAQs: [
      {
        question: "What is Humming Homes?",
        answer:
          "Humming Homes is a home membership service that brings together easy-to-use technology and experienced people to help you have more good days at home."
      },
      {
        question: "What areas does Humming Home operate in?",
        answer:
          "Currently, Humming Homes operates in the Hamptons and Westchester County, NY, Fairfield County, CT, and South Florida. We're launching new markets soon!"
      },
      {
        question: "How much does the service cost?",
        answer:
          "Humming Homes is a monthly subscription service that starts at $250 per month. Your individual subscription cost will depend on the size of your home, as well as its location."
      }
    ]
  },
  {
    section: "Humming Homes Team",
    FAQs: [
      {
        question: "Who will be responsible for my home?",
        answer:
          "Your Home Coordinator acts as a single point of contact for everything - think of them as the quarterback for your home. They are supported by 24/7 customer service and local in-market teams -- so no matter what might arise, the Humming Homes team is here to help you have more good days at home"
      },
      {
        question: "How do you vet my Home Coordinator?",
        answer:
          "We put every Humming Homes employee through an extensive screening process, as well as an external background check using Checkr. In addition to this in-depth screening, they go through a thorough training and onboarding process to ensure that your home is always in good hands."
      },
      {
        question: "What is Humming Homes expert network?",
        answer:
          "In addition to our Home Coordinators, we also have a network of local experts in every market where we operate. These experts have at least ten years of experience as an estate manager. They help design your proactive Humming Home plan and troubleshoot in the event that any significant issues arise."
      },
      {
        question: "What is your COVID-19 policy?",
        answer:
          "All Humming Homes employees have been fully vaccinated for COVID-19"
      }
    ]
  },
  {
    section: "Services",
    FAQs: [
      {
        question: "What services do you provide?",
        answer: `In addition to the Home Coordinator, we will find you trusted vendors to take care of all your home service needs. \n\n\nAdditionally, we catalog all your home's unique features - rooms, appliance information - and build a personalized Home Management plan for you`
      },
      {
        question: "What vendors do you have access to?",
        answer: `We have access to a network of service providers across any service that a homeowner might need. This includes landscaping, pool maintenance, handymen, electricians, HVAC professions, housekeeping and cleaning services -- as well as specialty vendors such as masonry, interior design, and chimney cleaning -- you name it! \n\n\n All vendors pass through our rigorous 6-step vetting process.`
      },
      {
        question: "Will you manage existing projects and vendors?",
        answer:
          "Yes! We're vendor agnostic and will happily manage any existing relationships or projects! All vendor management -- whether it's someone you've worked with in the past, or a new vendor that we facilitate -- is included in your monthly subscription."
      }
    ]
  },
  {
    section: "Support",
    FAQs: [
      {
        question: "How do I reach you if I need something?",
        answer:
          "We know that questions and issues can come up when you least expect them, which is why we built a chat feature right into the Humming Homes app. You can reach your Humming Homes team at any time by chat (the fastest way to reach us!), or if you prefer, you can also call or e-mail us."
      },
      {
        question: "What happens if I am dissatisfied with the service?",
        answer:
          "- Humming Homes offers a risk-free guarantee in which homeowners can to opt out of the agreement with 60 days' notice."
      },
      {
        question: "Will you be in-person at my home?",
        answer:
          "Our local expert will come on-site and in-person at your home. For individual projects, we will send licensed, pre-vetted vendors to your home to complete projects in a timely manner."
      },
      {
        question: "How often will someone come to my home?",
        answer:
          "Our customers have a monthly check-in with their dedicated Home Coordinator, who will dispatch experts and vendors as needed. How often someone comes to your home depends on your specific needs, timeline and more. "
      }
    ]
  }
];
